import { gql } from 'graphql-request'

export const GET_MY_PURCHASED_BOOK = gql`
  query GetMyPurchasedBook($bookId: Float!) {
    getMyPurchasedBook(book_id: $bookId) {
      penName {
        firstPenName
        user {
          avatarImgPath
          isPermanentBan
        }
      }
      category {
        id
        name
      }
      title
      coverImgPath
      cover
      isEnded
      bookType
      bookChapters {
        chapterName
        chapterTitle
        id
        runningNo
      }
      chapterPurchasedCount
    }
  }
`
